import { get, post } from './httpservices';
import { store } from '../store/store';
import { router } from '../router/index';

export async function dashboardData(date, type) {
    let resp;
    try {
        resp = await get('admin/dashboard?date=' + date + '&filter_by=' + type);
        return resp.data;
    }
    catch (e) {
        console.log(e);
        router.push('/500');
    }
}

